import React, { forwardRef, useState, useEffect, useRef } from "react";

import EventNotes from "../EventNotes";
import { createGuidId } from "../../../utils/teams-dragger";
import Header from "../Header";
import ChangeEventType from "../ChangeEventType";
import ConfirmButton from "../ConfirmButton";
import Submit from "../HandleSubmit";
import isEventValidForSubmit from "../helpers/isEventValidForSubmit";

const AddCornerEvent = forwardRef(
    (
        {
            setIsModalOpen,
            EVENT_TYPES,
            setEventsToShow,
            GOAL_TYPES,
            eventDetailsToAdd,
            setEventDetailsToAdd,
            setSides,
            goals,
            setGoals,
            isEditing,
            setIsEditing,
            PS_TYPES,
            PC_CORNERGOAL_TYPES,
            eventsToShow,
            matchId,
            matchData,
            setMatchData,
            formatApiData,
            homePlayers,
            awayPlayers,
            sides,
        },
        ref
    ) => {
        const submitData = (params) => {
            const {
                matchId,
                matchData,
                eventsToShow,
                setMatchData,
                formatApiData,
                homePlayers,
                awayPlayers,
                sides,
                setEventsToShow,
            } = params;

            const event = eventsToShow[eventsToShow.length - 1];
            const comment = event?.eventNotes ? event?.eventNotes.trim() : null;
            const teamId = event.sideSelected.id;
            const timestamp = event.timestamp;
            const minute = Math.ceil(timestamp / 60);
            const orderIndex = matchData.matchPosts.length;
            let quarter = "";

            switch (event.quarterSelected) {
                case "Q1":
                    quarter = 1;
                    break;
                case "Q2":
                    quarter = 2;
                    break;
                case "Q3":
                    quarter = 3;
                    break;
                case "Q4":
                    quarter = 4;
                    break;
                case "SO":
                    quarter = 0;
                    break;
            }
            const pcEvent = {
                type: "Penalty Corner",
                postType: 26,
                minute,
                team: teamId,
                isLive: true,
                orderIndex,
                quarter,
                ...(comment ? { additionalData: comment } : {}),
            };
            const update = {
                matchPosts: [...matchData.matchPosts, pcEvent],
            };
            Submit(matchId, matchData, update, setMatchData)
                .then((data) =>
                    formatApiData(
                        data,
                        sides,
                        setEventsToShow,
                        ...homePlayers,
                        ...awayPlayers
                    )
                )
                .catch((e) => console.error(e.message));
        };

        const [step, setStep] = useState("0,1");

        const isFirstRun = useRef(true);
        useEffect(() => {
            if (isFirstRun.current) {
                isFirstRun.current = false;
                return;
            }
            const event = eventsToShow[eventsToShow.length - 1];
            if (isEventValidForSubmit(event)) {
                submitData({
                    eventsToShow,
                    matchId,
                    matchData,
                    setMatchData,
                    formatApiData,
                    homePlayers,
                    awayPlayers,
                    sides,
                    setEventsToShow,
                });
            }
        }, [eventsToShow]);

        return (
            <div
                ref={ref}
                style={{
                    backgroundColor: "#E5E5E5",
                }}
            >
                <Header
                    eventDetails={eventDetailsToAdd}
                    setEventDetails={setEventDetailsToAdd}
                    setModalOpen={setIsModalOpen}
                    setSides={setSides}
                    goals={goals}
                    setGoals={setGoals}
                    isEditing={isEditing}
                />
                {[
                    "0",
                    "0,1",
                    "0,1,2",
                    "0,1,2,2.5",
                    "0,1,2,2.5,3.5",
                    "0,1,2,2.5,3.5,4",
                    "0,1,2,3",
                    "0,1,2,3,3.5",
                    "0,1,2,3,3.5,4",
                    "0,1,2,3,4",
                    "0,1,2,2.5,3.5,5",
                    "0,1,2,3,4,5",
                    "0,1,2,3,3.5,5",
                    "0,1,2,2.5,4",
                    "0,1,2,2.5,4,5",
                ].includes(step) && (
                    <ChangeEventType
                        EVENT_TYPES={EVENT_TYPES}
                        eventDetails={eventDetailsToAdd}
                        setEventDetails={setEventDetailsToAdd}
                        changeCallback={() => {
                            setStep("0");
                            setEventDetailsToAdd((data) => ({
                                ...data,
                                type: null,
                                typeOfEventTypeSelected: null,
                                typeOfCornerGoalSelected: null,
                                playerSelected: null,
                            }));
                        }}
                        confirmCallback={() => {
                            setStep("0,1");
                        }}
                        preventChange={true}
                    />
                )}
                <>
                    <EventNotes
                        textAreaValue={eventDetailsToAdd?.eventNotes}
                        showConfirmCancelButtons={
                            !!eventDetailsToAdd?.eventNotes?.length
                        }
                        confirmButtonAction={() => {}}
                        cancelButtonAction={() => {
                            setEventDetailsToAdd((data) => ({
                                ...data,
                                eventNotes: "",
                            }));
                        }}
                        onChange={(e) => {
                            setEventDetailsToAdd((data) => ({
                                ...data,
                                eventNotes: e.target.value,
                            }));
                        }}
                    />
                    <ConfirmButton
                        action={() => {
                            setEventsToShow((data) => {
                                return [
                                    ...data,
                                    {
                                        id: createGuidId(),
                                        ...eventDetailsToAdd,
                                    },
                                ];
                            });
                            setIsEditing(false);
                            setIsModalOpen(false);
                        }}
                    />
                </>
            </div>
        );
    }
);

export default AddCornerEvent;
